class SjTrainsController extends AbstractIntegrationController
	@register()
	@inject '$scope',
		'$uibModal'
		'configuration'
		'configurationOptions'
		'priceRegions'
		'shopGroups'
		'layoutTemplates'
		'vatRateOverrides'
		'IntegrationRepository'
		'Guid'
		'CopyService'
		'ConfigurationService'
		'ProductCategoryRepository'
		'parseBool'

	integrationId: 'sj_trains'

	initialize: ->
		@additionalButtonsTemplate = '@app/integration/sj-trains/sj-trains.additional-buttons.view.html'
		@configuration.is_active ?= false
		@defaultCostCenterId = null
		@defaultVatZoneId = '-1'
		@incrementalIds = ['current_device_id', 'current_product_id', 'current_product_variant_id']

		@initializeConfiguration()
		@initializeExcludedLoyaltyPointsProductCategories()

		@tabs = [
			{
				title: 'wbo.integration.sj_trains.credentials'
				selector: '#tab-credentials'
				form: 'vm.mainForm.credentials'
			}
			{
				title: 'wbo.integration.sj_trains.sync_shop_config'
				selector: '#tab-sync-shop-config'
				form: 'vm.mainForm.syncShopConfig'
			}
			{
				title: 'wbo.integration.sj_trains.sync_order_config'
				selector: '#tab-sync-order-config'
				form: 'vm.mainForm.syncOrderConfig'
			}
			{
				title: 'wbo.integration.sj_trains.incremental_ids'
				selector: '#tab-incremental-ids'
				form: 'vm.mainForm.incrementalIds'
			}
			{
				title: 'wbo.integration.sj_trains.loyalty_points_config'
				selector: '#tab-loyalty-points-config'
				form: 'vm.mainForm.loyaltyPointsConfig'
			}
		]

		@$scope.$watchGroup(
			@tabs.map((tab) => tab.form + '.$invalid'),
			(values) =>
				for value, index in values
					@tabs[index].error = value
		)

		# Wait for form to exist in UI
		unwatcher = @$scope.$watch 'vm.mainForm.syncShopConfig', (newValue) =>
			if newValue?
				unwatcher()

				@validateCostCenters()

	initializeConfiguration: ->
		@configuration.is_incremental_product_id_enabled ?= @ConfigurationService.isEnabled(
			'Shared.Core.IncrementalId.Device.Enabled'
		)
		@configuration.is_incremental_device_id_enabled ?= @ConfigurationService.isEnabled(
			'Shared.Core.IncrementalId.Product.Enabled'
		)

		for identifier in @incrementalIds
			@configuration[identifier] ?= 0

		@ensureObjectsInConfiguration(@configuration, ['companies', 'cost_centers', 'vat_zones', 'loyalty_points'])

		@initializeLoyaltyPoints()

		@processVatZones()

		if _.isEmpty(@configuration.companies)
			@configuration.companies = @configurationOptions.default_companies

		@initializeCostCenters()

	initializeCostCenters: ->
		@configuration.cost_centers = _.values(@configuration.cost_centers)

		if !_.find(@configuration.cost_centers, {is_default: true})
			@addCostCenter(true)

		for costCenter in @configuration.cost_centers
			costCenter.internal_id ?= @Guid.randomString()
			costCenter.is_default = @parseBool(costCenter.is_default)

			priceRegion = _.find(@priceRegions, {id: costCenter.price_region_id})
			shopGroup = _.find(@shopGroups, {id: costCenter.shop_group_id})

			if costCenter.is_default
				@defaultCostCenterId = costCenter.internal_id

			if !priceRegion?
				costCenter.price_region_id = null

			if !shopGroup?
				costCenter.shop_group_id = null

		@configuration.cost_centers = _.sortBy(@configuration.cost_centers, 'id')

	initializeLoyaltyPoints: ->
		@configuration.loyalty_points.is_enabled ?= false
		@configuration.loyalty_points.minimum ?= 800
		@configuration.loyalty_points.rounding ?= 100
		@configuration.loyalty_points.exchange_rate ?= 30

	initializeExcludedLoyaltyPointsProductCategories: ->
		excludedProductCategoryIds = @configuration.loyalty_points.excluded_product_category_ids
		@configuration.loyalty_points.excluded_product_categories = {}

		if _.isEmpty(excludedProductCategoryIds)
			return

		query = @ProductCategoryRepository.createQuery()
		query.criteria('id', 'IN', excludedProductCategoryIds)

		@ProductCategoryRepository
			.getEntities(query)
			.then (categories) -> _.map(categories, (category) -> {id: category.id, name: category.name})
			.then (categories) -> _.indexBy(categories, 'id')
			.then (categories) =>
				@configuration.loyalty_points.excluded_product_categories = categories

	setDefaultCostCenter: (selectedCostCenter) ->
		@defaultCostCenterId = selectedCostCenter.internal_id

		for costCenter in @configuration.cost_centers
			costCenter.is_default = costCenter.internal_id == @defaultCostCenterId

	validateCostCenters: ->
		@resetErrors()
		@mainForm.syncShopConfig.$setValidity('cost_centers', !_.isEmpty(@configuration.cost_centers))

		for id, count of _.countBy(@configuration.cost_centers, 'id')
			if id == null
				continue

			if count > 1
				@mainForm.syncShopConfig.$setValidity('cost_centers', false)

				@addErrorMessage('cost_centers', "Cost center #{id} has been used more than once")

	afterDisconnect: ->
		@configuration = {}

	save: ->
		@processVatZones()

		configuration = @CopyService.copy(@configuration)

		for costCenter in configuration.cost_centers
			delete costCenter.internal_id

		configuration.is_active = true
		configuration.cost_centers = _.indexBy(configuration.cost_centers, 'id')
		configuration.companies = _.indexBy(configuration.companies, 'id')

		for identifier in @incrementalIds
			if !@mainForm.incrementalIds[identifier]?.$dirty
				delete configuration[identifier]

		configuration.loyalty_points.excluded_product_category_ids = _.pluck(
			configuration.loyalty_points.excluded_product_categories,
			'id',
		)
		delete configuration.loyalty_points.excluded_product_categories

		super(configuration)
			.then (response) =>
				excludedProductCategories = @configuration.loyalty_points.excluded_product_categories
				@configuration = response.data
				@configuration.loyalty_points.excluded_product_categories = excludedProductCategories

				@initializeConfiguration()

	afterDisconnect: ->
		@configuration = {}

		@initializeConfiguration()

	addCostCenter: (isDefault = false) ->
		if _.isEmpty(@configuration.cost_centers)
			@configuration.cost_centers = []

		costCenter =
			id: null,
			internal_id: @Guid.randomString(),
			shop_group_id: null,
			price_region_id: null,
			is_default: isDefault,
		@configuration.cost_centers.push(costCenter)

		if isDefault
			@setDefaultCostCenter(costCenter)

	removeCostCenter: (costCenter) ->
		@mainForm.$setDirty()
		@configuration.cost_centers = _.reject(@configuration.cost_centers, {internal_id: costCenter.internal_id})

	syncShops: ->
		@IntegrationRepository.run(@integrationId, [], 'sync/shops')

	processVatZones: ->
		vatRateOverrideGroupIds = _.pluck(@vatRateOverrides, 'id')

		for overrideId, vatZone of @configuration.vat_zones
			if !vatRateOverrideGroupIds.includes(overrideId) && overrideId != @defaultVatZoneId
				delete @configuration.vat_zones[overrideId]

				continue

			vatZone.vat_rate_override_group_id = overrideId

	showOrderSyncModal: ->
		@$uibModal
			.open
				size: 'sm'
				templateUrl: '@app/integration/sj-trains/modals/sj-trains.order.modal.view.html'
				bindToController: true
				controllerAs: 'orderSelectModal'
				controller: ($uibModalInstance) ->
					$onInit: ->
						@modal = $uibModalInstance
			.result
			.then (orderId) =>
				@IntegrationRepository.run(@integrationId, null, "orders/#{orderId}")

	addLExcludedLoyaltyPointsProductCategory: (productCategory) ->
		productCategories = @configuration.loyalty_points.excluded_product_categories

		@loyaltyPointsProductCategoryId = null

		if !productCategory.id? || productCategories[productCategory.id]?
			return

		productCategories[productCategory.id] = {
			id: productCategory.id
			name: productCategory.name
		}

		@configuration.loyalty_points.excluded_product_categories = productCategories

	removeExcludedLoyaltyPointsProductCategory: (productCategoryId) ->
		if !@configuration.loyalty_points.excluded_product_categories[productCategoryId]?
			return

		delete @configuration.loyalty_points.excluded_product_categories[productCategoryId]
		@mainForm.$setDirty()

	hasExcludedLoyaltyPointsProductCategories: () ->
		return !_.isEmpty(@configuration.loyalty_points.excluded_product_categories)
